import React from 'react'
import type { CanvasObjective } from './strategyMapHelpers'
import './CanvasObjectiveCard.css'

interface Props {
  objective: CanvasObjective
  isFocused?: boolean
  isInChain?: boolean
  isDeemphasized?: boolean
  onClick?: () => void
}

export const CanvasObjectiveCard: React.FC<Props> = ({
  objective,
  isFocused,
  isInChain,
  isDeemphasized,
  onClick,
}) => {
  const showCvp =
    objective.perspective === 'Customer' &&
    objective.cvpAttributes &&
    objective.cvpAttributes.length > 0

  const classes = [
    'canvas-kn-objective-card',
    isFocused ? 'is-focused' : '',
    isInChain ? 'is-in-chain' : '',
    isDeemphasized ? 'is-deemphasized' : '',
  ].filter(Boolean).join(' ')

  // Stop propagation so the grid's empty-space click handler (in CanvasKNFrame)
  // doesn't fire and immediately clear the focus we're about to set.
  const handleClick = onClick
    ? (e: React.MouseEvent) => { e.stopPropagation(); onClick() }
    : undefined

  return (
    <div
      className={classes}
      data-objective-id={objective.id}
      role="figure"
      aria-label={objective.title}
      onClick={handleClick}
      style={onClick ? { cursor: 'pointer' } : undefined}
    >
      <span className="canvas-kn-objective-title">{objective.title}</span>
      {showCvp && (
        <div className="canvas-kn-card-cvp-caption">
          {objective.cvpAttributes!.join(' · ')}
        </div>
      )}
    </div>
  )
}
